import React from "react";
import Svg, { Path, Circle, G, Rect, Defs, ClipPath } from "react-native-svg";
import normalize from "app/utils/normalize";

interface Props {
  height?: number;
  width?: number;
}

const LogoFullThales = ({
  height = normalize(17),
  width = normalize(105),
  ...props
}: Props) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 484 58"
      fill="none"
      preserveAspectRatio="xMidYMin meet"
    >
      <G clip-path="url(#clip0_18_29)">
        <Path
          d="M484 42.1C484 49.9 481.7 52.2 475.5 54.1C468.8 56.1 456.9 57.4 449.8 57.4C441.4 57.4 430.9 56.9 422 54.8V45.8H471.3V33.5H436.4C425.9 33.5 422 30.6 422 20.4V15C422 6.9 424.4 4.5 430.9 2.8C437.5 1.1 448.3 0 455.4 0C464 0 474.3 0.7 483.2 2.7V11.7H434.7V22H469.6C480.1 22 484 24.8 484 35.1V42.1Z"
          fill="#2C2F73"
        />
        <Path
          d="M400 54.7C389.8 56.7 379.5 57.3 369.5 57.3C359.5 57.3 349.1 56.7 338.8 54.7V2.7C349 0.7 359.4 0 369.3 0C379.3 0 389.4 0.6 399.6 2.7V12H353.4V22.4H383.5V33.2H353.4V45.5H399.8V54.7H400Z"
          fill="#2C2F73"
        />
        <Path
          d="M321 54.7C311.8 56.7 302.6 57.3 293.7 57.3C284.8 57.3 275.4 56.8 266.2 54.7V1.29999H280.9V44.8H321V54.7Z"
          fill="#2C2F73"
        />
        <Path
          d="M249 55.1C244.1 56.5 237.6 57 232.8 57.1L210.1 11.3H208.8L186.2 57.1C181.4 57 175.7 56.5 170.8 55.1L199.5 1.40002H220L249 55.1Z"
          fill="#2C2F73"
        />
        <Path
          d="M219 41.4C219 46.7 214.7 50.9 209.4 50.9C204.1 50.9 199.9 46.6 199.9 41.4C199.9 36.1 204.2 31.9 209.4 31.9C214.7 31.9 219 36.1 219 41.4Z"
          fill="#5EBFD4"
        />
        <Path
          d="M153 55.1C148.3 56.5 143.3 56.9 138.3 57V33.7H101.8V57C96.8001 56.9 91.8001 56.4 87.1001 55.1V2.30002C91.8001 0.900024 96.8001 0.500024 101.8 0.400024V22.9H138.3V0.400024C143.3 0.500024 148.3 1.00002 153 2.30002V55.1Z"
          fill="#2C2F73"
        />
        <Path
          d="M66.2 12.1H40.4V56.1H25.8V12.1H0V2.7C11.1 0.7 22.3 0 33.1 0C43.9 0 55.1 0.6 66.2 2.7V12.1Z"
          fill="#2C2F73"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_18_29">
          <Rect width="484" height="57.4" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default LogoFullThales;
